module.exports = __webpack_public_path__ + "img/217.3283deb2.jpg";